export enum CategoryEnum {
  Tyres = 'Шины',
  Disks = 'Диски',
  Battery = 'Аккумуляторы',
}
